const HOWTO_HOST = 'howto.salesflare.com';
const HOWTO_LANGUAGES = ['en', 'nl', 'fr', 'de', 'es', 'it', 'pt'];
const HOWTO_DEFAULT_LANGUAGE = 'en';

// The how-to site only has a single Portuguese version
const APP_TO_HOWTO_LANGUAGE: Record<string, string> = {
    'pt-PT': 'pt',
    'pt-BR': 'pt'
};

/**
 * Points a how-to site URL to the version in the given app language.
 * Non how-to URLs and how-to URLs without a language segment (legacy slugs) are returned unchanged,
 * since adding a language to a legacy slug results in a 404.
 *
 * @param {String} url e.g. 'https://howto.salesflare.com/en/articles/1216231-how-does-salesflare-billing-work'
 * @param {String} [appLanguage] App language code, e.g. 'fr' or 'pt-BR'
 * @returns {String}
 */
export function localizeHowtoUrl(url: string, appLanguage?: string | null): string {

    let parsedUrl: URL;

    try {
        parsedUrl = new URL(url);
    }
    catch {
        return url;
    }

    if (parsedUrl.hostname !== HOWTO_HOST) {
        return url;
    }

    const mappedLanguage = appLanguage ? (APP_TO_HOWTO_LANGUAGE[appLanguage] ?? appLanguage) : HOWTO_DEFAULT_LANGUAGE;
    const howtoLanguage = HOWTO_LANGUAGES.includes(mappedLanguage) ? mappedLanguage : HOWTO_DEFAULT_LANGUAGE;
    const pathSegments = parsedUrl.pathname.split('/').filter(Boolean);

    if (pathSegments.length === 0) {
        pathSegments.push(howtoLanguage);
    }
    else if (HOWTO_LANGUAGES.includes(pathSegments[0])) {
        pathSegments[0] = howtoLanguage;
    }
    else {
        return url;
    }

    parsedUrl.protocol = 'https:';
    parsedUrl.pathname = '/' + pathSegments.join('/');

    return parsedUrl.toString();
}
